import Listar from '../views/Listar'
const routes = [
    {
        name: 'listarCteEmissor',
        path: '/emissor/conhecimentos',
        alias: ['/emissor/conhecimentos/index'],
        component: Listar,
    },
]

export default routes
